module.exports = __webpack_public_path__ + "static/media/Collections-in-villa-experiences-Desktop.850c22a9.jpg";